import { LoaderFunction, useLoaderData, useNavigate } from "react-router-dom";

import { get } from "api";
import { Button } from "atoms/button/Button";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import TopNav from "molecules/navbars/TopNav";
import { queryClient } from "pages/Root";
import { loadIfFlag } from "services/Flags";
import { formatCurrency } from "toolbox/Money";
import { waitObj } from "toolbox/Promise";
import { FormattedString } from "utils/FormattedStrings";

const loader = async (weightLossSubscriptionId: string | undefined) => {
  if (!weightLossSubscriptionId) return waitObj({ weightLossProgram: null });

  const weightLossPrograms = queryClient.fetchQuery(
    ["/healthie/subscriptions"],
    () => get("/healthie/subscriptions")
  );
  const weightLossProgram = (await weightLossPrograms).find(
    (wlp) => wlp.id === weightLossSubscriptionId
  );
  return waitObj({ weightLossProgram });
};

type LoaderData = Awaited<ReturnType<typeof loader>>;
export const weightLossProgramPDPLoader: LoaderFunction = loadIfFlag(
  "repeatmd-glp"
)(({ params }) => {
  return loader(params.id);
});

const WeightLossProgramPDP = () => {
  const navigate = useNavigate();
  const { weightLossProgram } = useLoaderData() as LoaderData;
  if (!weightLossProgram) return null;
  return (
    <>
      <TopNav
        startIconSVG={ChevronLeft}
        onStartIconClick={() => navigate("/shop/weight-loss-programs")}
      >
        <div className="flex max-h-[32px] items-center">
          <h1 className="text-l">Weight Loss Programs</h1>
        </div>
      </TopNav>
      <div className="flex flex-col bg-one">
        <div
          className="relative aspect-[16/9] w-full overflow-hidden bg-cover bg-center"
          style={{
            backgroundImage: `url(${weightLossProgram.imageUrl})`,
          }}
        />
      </div>
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center gap-6 px-4 pb-4 pt-8">
          <div className="flex flex-col items-center">
            <div className="text-center font-serif text-h1 text-primary">
              {weightLossProgram.name}
            </div>
            <div className="flex pt-3">
              <span className="text-sub1 text-primary">
                {formatCurrency(weightLossProgram.monthlyCost)}/
              </span>
              <span className="text-body1 text-primary">month</span>
            </div>
            <div className="pt-5 text-center text-body1 text-secondary">
              <FormattedString>
                {weightLossProgram.description || ""}
              </FormattedString>
            </div>
          </div>
        </div>
        <div className="sticky bottom-0 w-full bg-white p-4 pb-[calc(16px_+_env(safe-area-inset-bottom))]">
          <Button
            onClick={() =>
              navigate(
                `/pdp/weight-loss-program/checkout/${weightLossProgram.id}`
              )
            }
            fullWidth
          >
            Checkout now
          </Button>
        </div>
      </div>
    </>
  );
};

export default WeightLossProgramPDP;
